export default __webpack_public_path__ + "assets/images/40c142e94d41fff0e80a3549ccf16d5c.png";